import React, { useState } from 'react'
import './card-my-points.scss'

// import formatNumber from '../../../shared/utils/formatNumber.js'
import FormatDate from '../../../shared/utils/formartDate'
const CardMyPoints = props => {

  const { items, btnActive } = props;

  const [isShow, setIsShow] = useState(false);
  // console.log(btnActive)
  const handleHide = (e) => {
    // e.preventDefault();
    setIsShow(!isShow);
  }
  return (
    <div className="f-container-result">
      <div className="f-mypoints-result-search" onClick={e => handleHide(e)}>
        <div className="f-mypoints-result-search-container">
          <div className="f-result-info-mobile">
            <div className="f-mypoints-result-search-container-img">
              {(items.category === 'Toallas Higiénicas'  && !items.gift) &&
                <img className="f-img" src={'https://dev-portals-images.s3.amazonaws.com/NOL/products/toallas.svg'} alt="" />
              }
              {(items.category === 'Protectores Diarios'  && !items.gift) &&
                <img className="f-img" src={'https://dev-portals-images.s3.amazonaws.com/NOL/products/protectores.svg'} alt="" />
              }
              {(items.category === 'Nosotras Lacti'  && !items.gift) &&
                <img className="f-img" src={'https://dev-portals-images.s3.amazonaws.com/NOL/products/lacti.svg'} alt="" />
              }
              {(items.category === 'Pañitos Húmedos Intimos'  && !items.gift) &&
                <img className="f-img" src={'https://dev-portals-images.s3.amazonaws.com/NOL/products/pa%C3%B1itos.svg'} alt="" />
              }
              {(items.category === 'Tampones'  && !items.gift) &&
                <img className="f-img" src={'https://dev-portals-images.s3.amazonaws.com/NOL/products/tampones.svg'} alt="" />
              }
              {(items.category === 'Jabón Íntimo'  && !items.gift) &&
                <img className="f-img" src={'https://dev-portals-images.s3.amazonaws.com/NOL/products/jabon.svg'} alt="" />
              }
              {btnActive === 'Concursos' &&
                <img className="f-img" src={'https://dev-portals-images.s3.amazonaws.com/NOL/products/concursos.svg'} alt="" />
              }
              {btnActive === 'Acumulados' && items.gift &&
                <img className="f-img" src={'https://dev-portals-images.s3.amazonaws.com/NOL/products/regalo.svg'} alt="" />
              }
              {(items.category === 'Nosotras Maternidad'  && !items.gift) &&
                <img className="f-img" src={'https://dev-portals-images.s3.amazonaws.com/NOL/products/toallas.svg'} alt="" />
              }
              {(items.category === 'Cuidado V'  && !items.gift) &&
                <img className="f-img" src={'https://dev-portals-images.s3.amazonaws.com/NOL/products/Sensitiv.svg'} alt="" />
              }
            </div>
            <div className="f-mypoints-result-search-container-info">
              <div className="f-info-name-title">
                <h6 className="f-info-name-title">{items.gift ? 'Regalo Nosotras' : items.title}</h6>
                {btnActive === 'Acumulados' && <p>{!items.gift ? '' : items.detail}</p>}
                {btnActive === 'Concursos' && <p className={items.estado === 'Concursos' ? "f-state-result" : ""}>{items.estado}</p>}

              </div>
            </div>
            <span className={"f-icon icon-down f-card-arrow " + (isShow ? 'f-card-arrow-effect' : '')}></span>
          </div>
          <div className={`f-info-hide-container ` + (isShow ? 'f-unhide' : 'f-hide')}>
            <div>
              <p>Puntos</p>
              {btnActive === 'Acumulados' && <p>{!items.gift ? items.key ? `Clave:` : '' : ''}</p>}
              <p>Fecha ingreso:</p>
              {btnActive === 'Acumulados' && <p>Vencimiento:</p>}
            </div>
            <div className="f-info-hide-container-points">
              <h6 className={"f-my-poins-info " + (btnActive === 'Concursos' ? 'f-my-points-use' : '')}>{items.points} puntos</h6>
              {btnActive === 'Acumulados' && <p>
                {items.gift ? '' : items.key ? items.key.toUpperCase() : '' }
              </p>}

              <p>{FormatDate(items.creationDate)}</p>
              {btnActive === 'Acumulados' && <p>{FormatDate(items.expirationDate)}</p>}
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default CardMyPoints
